import { S3ErrorThrower } from './S3ErrorThrower';
import axios from 'axios';
import { Error } from '../utilities/CommonMethods';
import { ParsedError } from './DataParser';

class S3FileUpload {
    static async uploadFile(file, config, updateUploadProgress) {
        // Error Thrower :x:
        S3ErrorThrower(config, file);

        const fd = new FormData();
        const key = config.fields.key;
        const url = config.url;
        fd.append("key", key);
        fd.append("acl", config.fields['acl']);
        fd.append("Content-Type", config.fields['Content-Type']);
        fd.append("X-Amz-Credential", config.fields['x-amz-credential']);
        fd.append("X-Amz-Algorithm", config.fields['x-amz-algorithm']);
        fd.append("X-Amz-Date", config.fields['x-amz-date']);
        fd.append("Policy", config.fields['policy']);
        fd.append("X-Amz-Signature", config.fields['x-amz-signature']);
        fd.append("file", file);

        let data = await axios.post(url, fd, {
            onUploadProgress: (progressEvent) => {
                const progress = Math.round(progressEvent.loaded / progressEvent.total * 100);
                updateUploadProgress(progress);
            }
        })
            .then(res => {
                // console.log(res);
                return res;
            })
            .catch((error) => {
                Error('S3_VIDEO_UPLOAD_FAILED => ', error);
                return Promise.reject({
                    error: ParsedError(error, 'S3 Video Upload URL')
                });
            });

        return Promise.resolve({
            result: data
        });
    }
}

export default S3FileUpload;